export const filterValidHTMLAttributes = (props) => {
    if (!props) {
        return {};
    }
    const validHTMLAttributes = new Set();
    const commonAttributes = [
        'accesskey',
        'class',
        'contenteditable',
        'contextmenu',
        'dir',
        'draggable',
        'dropzone',
        'hidden',
        'id',
        'lang',
        'popover',
        'role',
        'spellcheck',
        'style',
        'tabindex',
        'title',
        'translate',
        'align',
        'alt',
        'bgcolor',
        'border',
        'cellpadding',
        'cellspacing',
        'crossorigin',
        'frame',
        'height',
        'ismap',
        'longdesc',
        'referrerpolicy',
        'rules',
        'sizes',
        'src',
        'srcset',
        'summary',
        'usemap',
        'width',
        'accept-charset',
        'accept',
        'action',
        'autocomplete',
        'autofocus',
        'checked',
        'cols',
        'dirname',
        'disabled',
        'download',
        'enctype',
        'for',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'href',
        'hreflang',
        'list',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'name',
        'onclick',
        'pattern',
        'placeholder',
        'readonly',
        'rel',
        'required',
        'rows',
        'size',
        'step',
        'target',
        'type',
        'wrap',
    ];
    commonAttributes.forEach((attr) => validHTMLAttributes.add(attr.toLowerCase()));
    ['className', 'children', 'dangerouslySetInnerHTML', 'ref'].forEach((reactProps) => validHTMLAttributes.add(reactProps.toLowerCase()));
    const filteredProps = {};
    Object.keys(props).forEach((key) => {
        const propKey = key.toLowerCase();
        const isDataOrAriaAttribute = propKey.startsWith('data-') || propKey.startsWith('aria-');
        if (validHTMLAttributes.has(propKey) || isDataOrAriaAttribute) {
            filteredProps[key] = props[key];
        }
    });
    return filteredProps;
};
//# sourceMappingURL=filterValidHTMLAttributes.js.map